import { Device, DeviceStatusInfo, ReverseGeocodeAddress, Zone } from "@fairfleet/geotab";
import DeviceFirmwareData from "../models/DeviceFirmwareData";
import FeedFirmwareData from "../models/FeedFirmwareData";

export default function combineFirmwareData(
  devices: Device[],
  channelData: Record<string, number | null>,
  feedData: Record<string, FeedFirmwareData>,
  statusInfos: Record<string, DeviceStatusInfo>,
  addresses: Record<string, ReverseGeocodeAddress>,
  zones: { [key: string]: Zone },
): DeviceFirmwareData[] {
  return devices.map(device => {
    // @ts-ignore
    const statusInfo = statusInfos[device.id];
    const address = addresses[device.id];

    return {
      device: device,
      channel: channelData[device.id],
      disconnected: channelData[device.id] === 0,
      ...feedData[device.id],
      statusData: statusInfo,
      address: address ? address.formattedAddress : "",
      zones:
        address && address.zones
          ? address.zones
              .map(zone => zones[zone?.id])
              .filter(z => z?.displayed)
              .map(z => z?.name)
              .join(", ")
          : "",
    };
  });
}
